<template>
  <div class="w1200">
    <!-- <div class="lottery">
        <span
            v-for="(item, index) in lottery.arr"
            :key="index"
            :class="lottery.active == index ? 'active' : ''"
            @click="lottery.active = index"
            >{{ item }}</span
        >
    </div> -->
    <div class="lottery">
      <span v-for="(item, index) in lottery.db" :key="index" :class="{ active: lottery.index == index, }"
        @click="lottery.index = index; lottery.active = item.dictValue; getList();">
        {{ item.dictLabel }}
      </span>
    </div>

    <div class="type">
      <div>
        <span v-for="(item, index) in type.arr" :key="index" :class="type.active == index ? 'active' : ''"
          @click="type.active = index; getList()">
          {{ item.label }}
        </span>
      </div>
      <span @click="gotoApplytrade">申请软件交易师</span>
    </div>

    <div class="table" v-loading="loading" element-loading-text="加载中...">

      <div class="head">
        <span> {{ (lottery.db[lottery.index] || {}).dictLabel }}软件交易汇总</span>
      </div>

      <el-table v-if="type.active == 0" :data="tableData" border style="width: 100%"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope">
            <template v-if="scope.$index <= 2">
              <img v-if="scope.$index == 0" src="@/assets/common/rank/1.gif">
              <img v-if="scope.$index == 1" src="@/assets/common/rank/2.gif">
              <img v-if="scope.$index == 2" src="@/assets/common/rank/3.gif">
            </template>
            <template v-else>
              {{ scope.$index + 1 }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="软件交易师" width="110">
          <template slot-scope="scope">
            <span class="dealer-name" @click="gotoDealer(scope.row)">
              {{ scope.row.softDealer }}
              <span v-if="hasCustomDemand(scope.row)" class="custom-demand-badge">众筹</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="hits" :show-overflow-tooltip="true" label="点击量" width="70" />
        <el-table-column prop="softName" min-width="160" :show-overflow-tooltip="true" label="软件名称" />
        <el-table-column prop="intro" min-width="200" :show-overflow-tooltip="true" label="软件简介" />
        <el-table-column prop="noVirus" :show-overflow-tooltip="true" label="发布者是否杀毒处理" width="160">
          <template slot-scope="scope">
            <span :class="scope.row.noVirus == 1 ? 'tag-yes' : 'tag-no'">{{ scope.row.noVirus == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :show-overflow-tooltip="true" label="软件来源">
          <template slot-scope="scope">
            <span class="src-tag" :style="sourceStyle(scope.row.softwareSourceIntro)">{{ scope.row.softwareSourceIntro
            }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="150" :show-overflow-tooltip="true" label="请平台技术再杀毒">
          <template slot-scope="scope">
            <!-- 0：可发起再杀毒；1：杀毒中；2：已完成。其余视为未申请 -->
            <!-- 仅自己的账号可操作再杀毒（platformVirusStatus==0 且 isOwn）；他人/非0仅展示状态 -->
            <span v-if="scope.row.platformVirusStatus == 0 && isOwn(scope.row)" class="kill-virus-btn"
              @click="killVirusAgain(scope.row)">请平台技术再杀毒<span class="kill-coin">{{ scope.row.coin }}</span>缩币</span>
            <span v-else-if="scope.row.platformVirusStatus == 1" class="kill-virus-tag killing">在杀毒</span>
            <span v-else-if="scope.row.platformVirusStatus == 2" class="kill-virus-tag done">已完成</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="发布时间" width="140">
          <template slot-scope="scope">
            <span class="time-sm">{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-table v-if="type.active == 1" :data="tableData" border style="width: 100%"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope">
            <template v-if="scope.$index <= 2">
              <img v-if="scope.$index == 0" src="@/assets/common/rank/1.gif">
              <img v-if="scope.$index == 1" src="@/assets/common/rank/2.gif">
              <img v-if="scope.$index == 2" src="@/assets/common/rank/3.gif">
            </template>
            <template v-else>
              {{ scope.$index + 1 }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="软件交易师" width="110">
          <template slot-scope="scope">
            <span class="dealer-name" @click="gotoDealer(scope.row)">
              {{ scope.row.softDealer }}
              <span v-if="hasCustomDemand(scope.row)" class="custom-demand-badge">众筹</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="softName" min-width="160" :show-overflow-tooltip="true" label="软件名称" />
        <el-table-column prop="intro" min-width="200" :show-overflow-tooltip="true" label="软件简介" />
        <el-table-column prop="noVirus" min-width="140" :show-overflow-tooltip="true" label="是否做过杀毒处理">
          <template slot-scope="scope">
            <span :class="scope.row.noVirus == 1 ? 'tag-yes' : 'tag-no'">{{ scope.row.noVirus == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :show-overflow-tooltip="true" label="软件来源">
          <template slot-scope="scope">
            <span class="src-tag" :style="sourceStyle(scope.row.softwareSourceIntro)">{{ scope.row.softwareSourceIntro
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" min-width="100" :show-overflow-tooltip="true" label="免费维护期" />
        <el-table-column :show-overflow-tooltip="true" label="发布时间" width="140">
          <template slot-scope="scope">
            <span class="time-sm">{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="!isOwn(scope.row)" type="text" size="mini" style="color:#E6A23C;padding-left:0"
              @click="openBuy(scope.row)">购买</el-button>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>

      <el-table v-if="type.active == 2" :data="tableData" border style="width: 100%"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope">
            <template v-if="scope.$index <= 2">
              <img v-if="scope.$index == 0" src="@/assets/common/rank/1.gif">
              <img v-if="scope.$index == 1" src="@/assets/common/rank/2.gif">
              <img v-if="scope.$index == 2" src="@/assets/common/rank/3.gif">
            </template>
            <template v-else>
              {{ scope.$index + 1 }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="软件定制人" width="180">
          <template slot-scope="scope">
            <span class="dealer-name" @click="gotoDealer(scope.row)">
              {{ scope.row.softDealer }}
              <span v-if="hasCustomDemand(scope.row)" class="custom-demand-badge">众筹</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" label="申请定制时间" width="180" />
        <el-table-column prop="customTitle" :show-overflow-tooltip="true" label="定制软件名称" width="200" />
        <el-table-column prop="customModeIntro" min-width="100" :show-overflow-tooltip="true" label="定制模式" />
        <el-table-column prop="demand" min-width="140" :show-overflow-tooltip="true" label="功能与需求说明" />
        <el-table-column :show-overflow-tooltip="true" label="预算金额" width="120">
          <template slot-scope="scope">
            {{ scope.row.budget != null ? scope.row.budget + '缩币' : '—' }}
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="已选开发团队" width="140">
          <template slot-scope="scope">
            {{ scope.row.selectedTeamName || '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="customStatusIntro" :show-overflow-tooltip="true" label="定制状态" width="120" />
        <el-table-column :show-overflow-tooltip="true" label="托管金额" width="120">
          <template slot-scope="scope">
            {{ scope.row.escrowAmountIntro || '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="developmentStartIntro" :show-overflow-tooltip="true" label="开发状态" width="110" />
        <el-table-column prop="acceptanceIntro" :show-overflow-tooltip="true" label="验收状态" width="110" />
      </el-table>

      <!-- <div class="pagination">
          <el-pagination
          background
          layout="total,prev, pager, next"
          :total="1000">
          </el-pagination>
      </div> -->

      <el-pagination style="padding-top:20px;text-align:right" background layout="prev, pager, next"
        @current-change="changePage" :page-size="listPagin.limit" :total="listPagin.total">
      </el-pagination>

    </div>

    <!-- 有偿转让软件购买（创建订购订单） -->
    <!-- 购买有偿转让软件：支付选择弹窗 -->
    <el-dialog :visible.sync="buyVisible" width="420px" append-to-body class="buy-dialog" :close-on-click-modal="false">
      <div class="buy-dialog-body">
        <div class="buy-product">
          <div class="buy-product-label">软件名称</div>
          <div class="buy-product-name">{{ buyRow && buyRow.softName }}</div>
        </div>

        <div class="buy-pay-label">选择支付方式</div>
        <div class="buy-pay-options">
          <div v-for="item in payOptions" :key="item.value" class="pay-option"
            :class="{ active: buyPayType === item.value }" @click="buyPayType = item.value">
            <i class="pay-icon" :class="item.icon"></i>
            <span class="pay-name">{{ item.label }}</span>
            <i v-if="buyPayType === item.value" class="check-mark el-icon-check"></i>
          </div>
        </div>
      </div>

      <div slot="footer" class="buy-dialog-footer">
        <el-button class="buy-btn-cancel" @click="buyVisible = false">取消</el-button>
        <el-button class="buy-btn-confirm" type="warning" :loading="buyLoading" @click="confirmBuy">
          <i class="el-icon-wallet"></i> 确认购买
        </el-button>
      </div>
    </el-dialog>

    <!-- 有偿转让软件：微信/支付宝扫码支付 -->
    <el-dialog :visible.sync="qrPay.show" :title="qrPay.payType === 'alipay' ? '支付宝支付' : '微信支付'" width="400px"
      append-to-body class="qr-pay-dialog" :close-on-click-modal="false" :show-close="true">
      <div class="qr-pay-body">
        <div class="qr-pay-amount" v-if="qrPay.amount">
          <span class="amount-value"><span class="amount-symbol">¥</span>{{ qrPay.amount }}</span>
          <span class="amount-label">支付金额</span>
        </div>
        <div class="qr-pay-amount title-only" v-else>{{ qrPay.title }}</div>

        <div class="qr-pay-guide">请使用{{ qrPay.payType === 'alipay' ? '支付宝' : '微信' }}扫描下方二维码完成支付</div>

        <div class="qr-pay-box">
          <div ref="qrCodeBox" class="qr-code"></div>
          <div class="qr-corner qr-corner-tl"></div>
          <div class="qr-corner qr-corner-tr"></div>
          <div class="qr-corner qr-corner-bl"></div>
          <div class="qr-corner qr-corner-br"></div>
          <div class="qr-scan-line"></div>
        </div>

        <div class="qr-pay-order" v-if="qrPay.orderNo">订单号：{{ qrPay.orderNo }}</div>

        <div class="qr-pay-tip">
          <i class="el-icon-success tip-icon"></i>
          <div class="tip-body">
            <div class="tip-title">温馨提示</div>
            <div class="tip-content">支付成功后系统会自动更新订单状态，请耐心等待，无需手动刷新。</div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { queryLotteryType } from "@/api/common"
import { softwareList } from '@/api/home'
import { softwarePaidTransferOrder, softwareSourceList, softwareHits, softwareAntivirusApply } from '@/api/software'
import QRCode from 'qrcodejs2'

export default {
  data() {
    return {
      lottery: {
        db: [],
        active: '0',
        index: 0
      },
      listPagin: {
        page: 1,
        limit: 15,
        total: 0
      },
      type: {
        // 软件分类 FREE：免费厅 PAID_TRANSFER：有偿转让厅 CUSTOM：定制软件厅
        arr: [
          { label: '免费厅', value: 'FREE' },
          { label: '有偿转让厅', value: 'PAID_TRANSFER' },
          { label: '定制软件厅', value: 'CUSTOM' },
        ],
        active: 0,
      },
      tableData: [],
      loading: false,  // 切换彩种/分类/翻页时的加载动画

      // 有偿转让软件购买（下单）
      buyVisible: false,
      buyRow: null,
      buyPayType: 'wxpay',
      buyLoading: false,
      payOptions: [
        // { value: 'balancepay', label: '余额支付', icon: 'el-icon-wallet' },
        { value: 'wxpay', label: '微信支付', icon: 'el-icon-chat-dot-round' },
        { value: 'alipay', label: '支付宝支付', icon: 'el-icon-money' },
      ],

      // 有偿转让软件：微信/支付宝扫码支付弹窗
      qrPay: {
        show: false,
        url: '',        // 二维码内容：后端返回的 codeUrl
        title: '',      // 订单标题
        amount: '',     // 订单金额
        orderNo: '',    // 订单号
        payType: '',    // wxpay / alipay
      },
      ws: null,         // 支付结果 WebSocket

      // 软件来源配色：label -> { bg, fg, bd }
      sourceColorMap: {},

    };
  },
  mounted() {
    // 获取彩种
    queryLotteryType().then(res => {
      this.lottery.db = (res.data || []).map(item => {
        return { dictLabel: item.dictLabel, dictValue: item.dictValue }
      })
      // 彩种加载完成后，使用第一个彩种刷新列表
      if (this.lottery.db.length) {
        this.lottery.active = this.lottery.db[0].dictValue
        this.getList()
      }
    })
    // 加载软件来源列表，用于来源列按类型配色
    this.getSoftwareSources()
  },
  beforeDestroy() {
    // 关闭支付 WebSocket，避免内存泄漏
    if (this.ws) {
      try { this.ws.close() } catch (e) { }
      this.ws = null
    }
  },
  methods: {
    getList() {
      this.loading = true
      softwareList({
        preType: this.lottery.active,
        softwareSource: '',
        classification: this.type.arr[this.type.active].value,
        pageNumber: this.listPagin.page,
        pageSize: this.listPagin.limit
      }).then(res => {
        console.log("res", res);
        let { rows, total } = res;
        this.tableData = rows
        this.listPagin.total = total
      }).catch(err => {
        console.log('err', err)
      }).finally(() => {
        this.loading = false
      })
    },
    // 分页状态变化
    changePage(e) {
      this.listPagin.page = e;
      this.getList()
    },
    // 申请软件交易师
    gotoApplytrade() {
      this.$router.push('/personalCenter/suoshuiruanjian/apply_jys')
    },
    // 打开购买弹窗（有偿转让软件）
    openBuy(row) {
      this.buyRow = row
      this.buyPayType = 'wxpay'
      this.buyVisible = true
    },
    // 确认购买：调用创建有偿转让软件订购订单接口
    confirmBuy() {
      if (!this.buyRow) return
      const softwareId = this.buyRow.id
      if (softwareId === undefined || softwareId === null || softwareId === '') {
        this.$message.warning('未获取到软件ID，无法购买')
        return
      }
      this.buyLoading = true
      // 微信/支付宝支付需额外传 notifyUrl、returnUrl，值与当前站点域名一致
      // (开发环境 VUE_APP_BASE_API=http://sswserver.frp.hexinle.top:18080；生产=线上域名，打包后自动切换)
      const callbackUrl = process.env.VUE_APP_BASE_API || ''
      const orderParams = {
        softwareId: Number(softwareId),
        payType: this.buyPayType,
      }
      if (this.buyPayType !== 'balancepay') {
        // 微信用 /wx/ 前缀，支付宝用 /aliy/ 前缀，回调路径与支付渠道对应
        const prefix = this.buyPayType === 'alipay' ? 'stage-api/aliy' : 'stage-api/wx'
        orderParams.notifyUrl = callbackUrl + prefix + '/productNotify'
        orderParams.returnUrl = callbackUrl + prefix + '/productReturn'
      }
      softwarePaidTransferOrder(orderParams).then(res => {
        // 兼容拦截器两种返回形态：{code,msg,data} 或 裸 {header,data} 原样透传
        const base = res && res.data !== undefined ? res.data : res
        const data = (base && base.data !== undefined) ? base.data : (base || {})
        const code = res && res.code !== undefined ? res.code : (base && base.header && base.header.ret)
        if (code === 200 || code === '0' || code === 0 || (data && data.orderNo)) {
          this.buyVisible = false
          // 余额支付：无扫码，直接提示下单成功
          if (this.buyPayType === 'balancepay') {
            this.$message.success('下单成功')
            return
          }
          // 微信/支付宝：后端返回 codeUrl（二维码地址），弹出扫码图片
          if (data && data.codeUrl) {
            this.openQrPay(data)
          } else {
            this.$message.success('下单成功')
          }
        } else {
          const msg = (res && res.msg) || (base && base.header && base.header.msg) || '下单失败'
          this.$message.error(msg)
        }
      }).catch(err => {
        this.$message.error((err && err.msg) ? err.msg : '下单失败，请稍后重试')
      }).finally(() => {
        this.buyLoading = false
      })
    },
    // 弹出微信/支付宝扫码支付二维码，并监听支付成功
    openQrPay(data) {
      this.qrPay.show = true
      this.qrPay.url = data.codeUrl
      this.qrPay.title = data.title || '有偿转让软件'
      this.qrPay.amount = data.totalPrice || ''
      this.qrPay.orderNo = data.orderNo || ''
      this.qrPay.payType = (data.payType && data.payType.value) || this.buyPayType

      // 建立 WebSocket 监听支付结果（参考 suobi_chongzhi.vue）
      if (this.ws) {
        try { this.ws.close() } catch (e) { }
        this.ws = null
      }
      const params = `/${this.vuex_token}?userId=${this.vuex_userInfo && this.vuex_userInfo.userId}&businessType=pay`
      // 去掉 BASE_WS 末尾可能的斜杠，避免拼出 //stage-api 双斜杠（env 不热更新，此处兜底）
      const wsBase = (process.env.VUE_APP_BASE_WS || '').replace(/\/+$/, '')
      const wsUrl = wsBase + '/stage-api/pay-websocket' + params
      console.log('[支付WS] 连接地址', wsUrl)
      this.ws = new WebSocket(wsUrl)
      const that = this
      this.ws.onopen = function () {
        console.log('[支付WS] 连接已建立，等待支付结果推送')
      }
      this.ws.onerror = function (err) {
        console.error('[支付WS] 连接出错', err)
      }
      this.ws.onclose = function (e) {
        console.log('[支付WS] 连接关闭 code=', e && e.code, 'reason=', e && e.reason)
      }
      this.ws.onmessage = function (event) {
        console.log('[支付WS] 收到消息', event.data)
        let obj = null
        try {
          obj = JSON.parse(event.data)
        } catch (e) {
          obj = null
        }
        if (!obj) return
        // 后端支付成功推送（真实字段）：code=200 且 status=TRANSFER_SUCCESS
        // data=SUCCESS / message 含「支付成功」 同为成功标志，命中其一即视为支付成功
        const isPaid = obj.code === 200 && (
          obj.status === 'TRANSFER_SUCCESS' ||
          obj.data === 'SUCCESS' ||
          (typeof obj.message === 'string' && obj.message.indexOf('支付成功') > -1)
        )
        if (isPaid) {
          that.qrPay.show = false
          that.$successToast({ text: '支付成功', sub: obj.message || '订单已支付', duration: 2000 })
          // 不主动刷新列表：支付结果以后端状态为准，用户需要时自行切换/拉取
        }
      }

      // 生成二维码图片
      this.$nextTick(() => {
        const container = this.$refs.qrCodeBox
        if (!container) return
        while (container.firstChild) {
          container.removeChild(container.firstChild)
        }
        new QRCode(container, {
          text: this.qrPay.url,
          width: 220,
          height: 220,
        })
      })
    },
    // 加载软件来源列表，按来源类型构建配色映射
    getSoftwareSources() {
      softwareSourceList().then(res => {
        const list = this.normalizeSource(res)
        const palette = [
          { bg: '#e6f7ff', fg: '#096dd9', bd: '#91d5ff' },
          { bg: '#f6ffed', fg: '#389e0d', bd: '#b7eb8f' },
          { bg: '#fff7e6', fg: '#d46b08', bd: '#ffd591' },
          { bg: '#f9f0ff', fg: '#722ed1', bd: '#d3adf7' },
          { bg: '#fff1f0', fg: '#cf1322', bd: '#ffa39e' },
          { bg: '#e6fffb', fg: '#08979c', bd: '#87e8de' },
        ]
        const map = {}
        list.forEach((item, i) => {
          const label = typeof item === 'string' ? item : (item.dictLabel || item.label || '')
          if (label) map[label] = palette[i % palette.length]
        })
        this.sourceColorMap = map
      }).catch(() => { })
    },
    // 兼容软件来源接口多种返回结构
    normalizeSource(res) {
      const data = res && (res.data !== undefined ? res.data : res)
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      return []
    },
    // 来源列样式：按类型返回不同配色
    sourceStyle(label) {
      const c = this.sourceColorMap[label]
      if (c) return { backgroundColor: c.bg, color: c.fg, borderColor: c.bd }
      return { backgroundColor: '#f5f5f5', color: '#666', borderColor: '#d9d9d9' }
    },
    // 该行软件交易师是否发布过审核通过的定制软件需求：0-否 1-是
    // 用于「软件交易师」列昵称右侧的「众筹」标签
    hasCustomDemand(row) {
      if (!row || typeof row !== 'object') return false
      const v = row.hasCustomDemand
      return v === 1 || v === '1' || v === true
    },
    // 是否为当前登录用户自己的数据：列表行的发布者 userId 与缓存 vuex_userInfo.userId 一致
    // 有偿转让厅「购买」按钮：自己的数据不显示购买
    isOwn(row) {
      const me = this.vuex_userInfo && this.vuex_userInfo.userId
      if (!me || !row) return false
      const owner = row.userId
      if (owner === undefined || owner === null || owner === '') return false
      return String(owner) === String(me)
    },
    // 点击软件交易师：先处理点击量，再进入该交易师信息页
    gotoDealer(row) {
      // 先调点击量接口（不变）
      const id = row.id
      if (id !== undefined && id !== null && id !== '') {
        softwareHits(Number(id)).catch(() => { })
      }
      // 新页签打开交易师详情页：原列表页不会被销毁，也就不存在返回刷新问题
      const routeData = this.$router.resolve({
        path: '/suoshuiruanjian/dealer',
        query: { dealer: row.softDealer || '', userId: row.userId },
      })
      window.open(routeData.href, '_blank')
    },
    // 点击「请平台技术再杀毒」：二次确认后调用再杀毒申请接口
    killVirusAgain(row) {
      const softwareId = row.id
      if (softwareId === undefined || softwareId === null || softwareId === '') {
        this.$message.warning('未获取到软件ID，无法申请')
        return
      }
      this.$confirm(
        `确认对软件「${row.softName || ''}」申请平台再杀毒？将扣除 ${row.coin} 缩币。`,
        '再杀毒确认',
        { confirmButtonText: '确认申请', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        softwareAntivirusApply({ softwareId: Number(softwareId) }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg || '申请成功')
            this.getList()
          } else {
            this.$message.error(res.msg || '申请失败')
          }
        }).catch(err => {
          this.$message.error((err && err.msg) ? err.msg : '申请失败，请稍后重试')
        })
      }).catch(() => { })
    },
  }
};
</script>

<style lang="scss" scoped>
.lottery {
  margin: 10px 0;

  span {
    display: inline-block;
    padding: 20px 30px;
    background-color: #dbdbdb;
    cursor: pointer;

    &.active {
      background-color: #93D2F3;
      color: #000;
    }
  }
}

.type {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  margin: 20px 0;

  >div {
    span {
      display: inline-block;
      padding: 5px 30px;
      border: 1px solid #999;
      margin-right: 10px;
      border-radius: 10px;
      background-color: #dbdbdb;
      cursor: pointer;

      &.active {
        background-color: #93d2f3;
      }
    }
  }

  >span {
    border: 1px solid #999;
    padding: 5px 20px;
    border-radius: 20px;
    cursor: pointer;
  }
}

.table {
  overflow: hidden;

  .head {
    padding-top: 20px;
    margin: 20px 0;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 5px solid #3f7bae;


    span {
      display: inline-block;
      color: #3f7bae;
      font-weight: bold;
      font-size: 20px;
    }
  }

  .pagination {
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 软件交易师：加色加粗、可点击
  .dealer-name {
    display: flex;
    align-items: center;
    color: #1890ff;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  // 软件交易师列：昵称右侧的「众筹」标签
  .custom-demand-badge {
    display: inline-block;
    vertical-align: top;
    margin-left: 4px;
    background-color: #f56c6c;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    padding: 0 4px;
    border-radius: 7px;
    transform: scale(0.9);
    transform-origin: left center;
    white-space: nowrap;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  // 发布时间：文字缩小
  .time-sm {
    font-size: 12px;
    color: #606266;
  }

  // 杀毒状态：是/否 不同标签样式
  .tag-yes {
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    background-color: #f6ffed;
    color: #389e0d;
    border: 1px solid #b7eb8f;
    font-weight: bold;
  }

  .tag-no {
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    background-color: #fff1f0;
    color: #cf1322;
    border: 1px solid #ffa39e;
    font-weight: bold;
  }

  // 软件来源：按类型动态配色（背景/文字/边框由 sourceStyle 内联控制）
  .src-tag {
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    border: 1px solid;
    font-weight: bold;
  }

  // 请平台技术再杀毒：可点击，数字加粗加重
  .kill-virus-btn {
    color: #d46b08;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    .kill-coin {
      color: #cf1322;
      font-weight: bold;
      font-size: 15px;
      padding: 0 2px;
    }
  }

  // 再杀毒状态标签：在杀毒 / 已完成
  .kill-virus-tag {
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    font-weight: bold;
    border: 1px solid;

    &.killing {
      color: #d46b08;
      background-color: #fff7e6;
      border-color: #ffd591;
    }

    &.done {
      color: #389e0d;
      background-color: #f6ffed;
      border-color: #b7eb8f;
    }
  }

}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
  /* 彩种切换：平分一行 */
  .lottery {
    display: flex;
    flex-wrap: wrap;

    span {
      flex: 1;
      min-width: 80px;
      text-align: center;
      padding: 12px 4px;
      font-size: 15px;
    }
  }

  /* 分类切换 + 申请按钮：纵向堆叠 */
  .type {
    flex-direction: column;
    align-items: stretch;
    row-gap: 10px;

    >div {
      display: flex;
      flex-wrap: wrap;

      span {
        padding: 6px 14px;
        margin-right: 8px;
        margin-bottom: 6px;
        font-size: 14px;
      }
    }

    >span {
      align-self: flex-start;
      padding: 6px 16px;
      font-size: 13px;
    }
  }

  /* 表格标题：缩小字号，允许换行 */
  .table {
    .head {
      flex-wrap: wrap;

      span {
        max-width: 100%;
        font-size: 16px;
        line-height: 1.6;
      }
    }
  }

  /* 分页：窄屏居中显示，避免右对齐被截断 */
  ::v-deep .el-pagination {
    padding-top: 16px !important;
    text-align: center !important;
  }
}
</style>

<style>
/* 有偿转让软件：微信/支付宝扫码支付弹窗（全局样式，确保 append-to-body 生效） */
.qr-pay-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
}

.qr-pay-dialog .el-dialog__header {
  padding: 0;
  background: linear-gradient(135deg, #07c160 0%, #0a9d52 100%);
  text-align: center;
  position: relative;
}

.qr-pay-dialog .el-dialog__title {
  display: inline-block;
  padding: 18px 20px 16px;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}

.qr-pay-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 14px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  transition: background 0.2s;
}

.qr-pay-dialog .el-dialog__headerbtn:hover {
  background: rgba(255, 255, 255, 0.32);
}

.qr-pay-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 30px;
}

.qr-pay-dialog .el-dialog__body {
  padding: 0;
}

.qr-pay-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 26px 26px;
  background: #fff;
}

.qr-pay-body .qr-pay-amount {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.qr-pay-body .qr-pay-amount.title-only {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.qr-pay-body .qr-pay-amount .amount-value {
  font-size: 34px;
  font-weight: 800;
  color: #E92728;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(233, 39, 40, 0.12);
}

.qr-pay-body .qr-pay-amount .amount-value .amount-symbol {
  font-size: 20px;
  margin-right: 2px;
  vertical-align: 4px;
}

.qr-pay-body .qr-pay-amount .amount-label {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  letter-spacing: 1.5px;
  padding: 3px 10px;
  background: #f5f7fa;
  border-radius: 20px;
}

.qr-pay-body .qr-pay-guide {
  font-size: 13px;
  color: #606266;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.3px;
}

.qr-pay-body .qr-pay-box {
  position: relative;
  background: #fff;
  padding: 14px;
  border-radius: 14px;
  border: 1px solid #e8f5ec;
  box-shadow: 0 6px 22px rgba(7, 193, 96, 0.10);
  margin-bottom: 4px;
}

.qr-pay-body .qr-pay-box .qr-code {
  width: 210px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.qr-pay-body .qr-pay-box .qr-corner {
  position: absolute;
  width: 16px;
  height: 16px;
  border: 2px solid #07c160;
}

.qr-pay-body .qr-pay-box .qr-corner-tl {
  top: 4px;
  left: 4px;
  border-right: none;
  border-bottom: none;
  border-radius: 4px 0 0 0;
}

.qr-pay-body .qr-pay-box .qr-corner-tr {
  top: 4px;
  right: 4px;
  border-left: none;
  border-bottom: none;
  border-radius: 0 4px 0 0;
}

.qr-pay-body .qr-pay-box .qr-corner-bl {
  bottom: 4px;
  left: 4px;
  border-right: none;
  border-top: none;
  border-radius: 0 0 0 4px;
}

.qr-pay-body .qr-pay-box .qr-corner-br {
  bottom: 4px;
  right: 4px;
  border-left: none;
  border-top: none;
  border-radius: 0 0 4px 0;
}

.qr-pay-body .qr-pay-box .qr-scan-line {
  position: absolute;
  left: 14px;
  right: 14px;
  top: 14px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #07c160, transparent);
  box-shadow: 0 0 8px rgba(7, 193, 96, 0.55);
  animation: qr-scan 2.4s ease-in-out infinite;
  border-radius: 2px;
}

.qr-pay-body .qr-pay-order {
  margin-top: 12px;
  padding: 5px 12px;
  background: #f7f8fa;
  border-radius: 20px;
  font-size: 11.5px;
  color: #909399;
  letter-spacing: 0.3px;
}

.qr-pay-body .qr-pay-tip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-top: 18px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #f0fbf5 0%, #f7fcf9 100%);
  border-radius: 12px;
  box-sizing: border-box;
  border: 1px solid #d8f0e3;
}

.qr-pay-body .qr-pay-tip .tip-icon {
  color: #07c160;
  font-size: 18px;
  margin-top: 1px;
  flex-shrink: 0;
}

.qr-pay-body .qr-pay-tip .tip-body {
  text-align: left;
}

.qr-pay-body .qr-pay-tip .tip-body .tip-title {
  font-size: 13px;
  font-weight: 700;
  color: #1f7a4d;
  margin-bottom: 4px;
}

.qr-pay-body .qr-pay-tip .tip-body .tip-content {
  font-size: 12px;
  color: #5a8a72;
  line-height: 1.6;
}

@keyframes qr-scan {
  0% {
    transform: translateY(0);
    opacity: 0.8;
  }

  50% {
    transform: translateY(194px);
    opacity: 1;
  }

  100% {
    transform: translateY(0);
    opacity: 0.8;
  }
}

/* 有偿转让软件：支付选择弹窗（全局样式，确保 append-to-body 生效） */
.buy-dialog .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);
}

.buy-dialog .el-dialog__header {
  padding: 0;
  background: linear-gradient(135deg, #ff9a2e 0%, #f57c00 100%);
  text-align: center;
}

.buy-dialog .el-dialog__title {
  display: inline-block;
  padding: 18px 20px;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}

.buy-dialog .el-dialog__headerbtn {
  top: 13px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s;
}

.buy-dialog .el-dialog__headerbtn:hover {
  background: rgba(255, 255, 255, 0.35);
}

.buy-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 32px;
}

.buy-dialog .el-dialog__body {
  padding: 0;
}

.buy-dialog .el-dialog__footer {
  padding: 0 24px 22px;
  border-top: none;
}

.buy-dialog .buy-dialog-body {
  padding: 22px 24px 8px;
  background: #fff;
}

.buy-dialog .buy-product {
  margin-bottom: 22px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #fff8f0 0%, #fff 100%);
  border-radius: 12px;
  border: 1px solid #ffe4cc;
}

.buy-dialog .buy-product .buy-product-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.buy-dialog .buy-product .buy-product-name {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  line-height: 1.5;
}

.buy-dialog .buy-pay-label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.buy-dialog .buy-pay-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buy-dialog .pay-option {
  position: relative;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1.5px solid #e4e7ed;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.buy-dialog .pay-option:hover {
  border-color: #f7b068;
  background: #fffbf5;
}

.buy-dialog .pay-option.active {
  border-color: #ff9a2e;
  background: linear-gradient(135deg, #fff8f0 0%, #fff 100%);
  box-shadow: 0 4px 12px rgba(255, 154, 46, 0.12);
}

.buy-dialog .pay-option .pay-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
}

.buy-dialog .pay-option:nth-child(1) .pay-icon {
  background: #fff4e6;
  color: #ff9a2e;
}

.buy-dialog .pay-option:nth-child(2) .pay-icon {
  background: #e6f7ed;
  color: #07c160;
}

.buy-dialog .pay-option:nth-child(3) .pay-icon {
  background: #e6f4ff;
  color: #1677ff;
}

.buy-dialog .pay-option .pay-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.buy-dialog .pay-option .check-mark {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff9a2e;
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.buy-dialog .buy-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buy-dialog .buy-btn-cancel {
  width: 110px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  color: #606266;
  border-color: #dcdfe6;
}

.buy-dialog .buy-btn-cancel:hover {
  color: #ff9a2e;
  border-color: #ff9a2e;
  background: #fff8f0;
}

.buy-dialog .buy-btn-confirm {
  width: 160px;
  height: 40px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  border: none;
  background: linear-gradient(135deg, #ff9a2e 0%, #f57c00 100%);
  box-shadow: 0 6px 16px rgba(245, 124, 0, 0.28);
}

.buy-dialog .buy-btn-confirm:hover {
  background: linear-gradient(135deg, #ffab4a 0%, #f78c1a 100%);
}

.buy-dialog .buy-btn-confirm i {
  margin-right: 4px;
  font-size: 14px;
}
</style>
